import React from "react";
import { GiPlantRoots, GiHerbsBundle, GiBrain } from "react-icons/gi";
import { FaBolt, FaSmileBeam } from "react-icons/fa";
import "./VisualizationSection1.css";

const steps = [
  {
    id: 1,
    icon: <GiPlantRoots />,
    title: "Voltage Changes",
    text: "Plants reflect human movements through voltage changes, similar to 'action potentials' in human brain cells.",
  },
  {
    id: 2,
    icon: <FaBolt />,
    title: "Voltage Measurement",
    text: "A voltage meter measures the potential difference between the plant root and leaf using electrodes.",
  },
  {
    id: 3,
    icon: <GiHerbsBundle />,
    title: "Plant Verification",
    text: "The system has been verified with Mimosa, Basil, Tomato, and Salad plants.",
  },
  {
    id: 4,
    icon: <FaSmileBeam />,
    title: "Ground Truth Emotions",
    text: "Facial emotions of a person sitting near the plant are recorded alongside electrical signals.",
  },
  {
    id: 5,
    icon: <GiBrain />,
    title: "Machine Learning Model",
    text: "A machine learning model identifies emotions based on human and plant signal correlations.",
  },
];

const VisualizationSection1 = () => {
  return (
    <section className="visualization-section body.app1-page">
      {/* Section Header */}
      <h2 className="section-title">How Does Biolingo Work?</h2>
      <p className="section-subheader">
        Explore the step-by-step process of analyzing human emotions through plants.
      </p>

      {/* Steps Cards */}
      <div className="steps-container">
        {steps.map((step) => (
          <div key={step.id} className="step-card">
            <div className="step-number">{step.id}</div>
            <div className="step-icon">{step.icon}</div>
            <h4 className="step-title">{step.title}</h4>
            <p className="step-text">{step.text}</p>
          </div>
        ))}
        <div className="connecting-line"></div>
      </div>

      <div className="videos-container">
        <div className="video-element-wrapper">
          <video className="video-element" controls>
            <source src="Videos/EmotionMovie.mov" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      <div className="video-element-wrapper">
        <video className="video-element" controls>
          <source src="Videos/MimosaReadingHuman.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
    </section>
  );
};

export default VisualizationSection1;
